// 261012 학원·교회 회원 첫 화면(기관 템플릿) — 순수 함수만(node 테스트 대상). 화면·API 는 OrgHome.vue / ServiceLanding.vue / QrLanding.vue.
// 기획서 C:/Temp/jump-org-home-261012-docs/specs/2026-10-12-org-home-template-design.md
const CACHE_PREFIX = 'gp-org-home:'; // 마지막 판정(앱 시작 깜빡임 방지) — 회원 번호별
const ASK_PREFIX = 'gp-org-home-ask:'; // 저장 뒤 묻기에 [아니요] — 회원 번호·현판 코드별

const safe = fn => { try { return fn(); } catch (_) { return null; } }; // 사생활 보호 모드 등 저장소가 막혀도 화면은 그린다

export const readOrgHomeCache = (storage, userNo) => {
  if (!userNo) return null;
  const v = safe(() => JSON.parse(storage.getItem(CACHE_PREFIX + userNo) || 'null'));
  return v && (v.mode === 'ORG' || v.mode === 'GANPANON') ? v : null;
};

export const writeOrgHomeCache = (storage, userNo, home) => {
  if (userNo && home) safe(() => storage.setItem(CACHE_PREFIX + userNo, JSON.stringify(home)));
};

export const askedOrgHome = (storage, userNo, qrCode) => !!safe(() => storage.getItem(`${ASK_PREFIX}${userNo}:${qrCode}`));

export const markAskedOrgHome = (storage, userNo, qrCode) => {
  if (userNo && qrCode) safe(() => storage.setItem(`${ASK_PREFIX}${userNo}:${qrCode}`, '1'));
};

/** 로그아웃 — 이 기기의 기관 템플릿 기억을 모두 지운다(rules/25 §1). 다른 기능 키는 건드리지 않는다. */
export const clearOrgHomeStorage = storage => {
  const keys = safe(() => Array.from({ length: storage.length }, (_, i) => storage.key(i))) || [];
  keys.filter(k => k && (k.startsWith(CACHE_PREFIX) || k.startsWith(ASK_PREFIX))).forEach(k => safe(() => storage.removeItem(k)));
};

// 학원 템플릿 바로가기 — 학부모에게 쓸모 있는 칸만, 이 순서로. 수강료·레벨테스트·체험 같은 처음 온 손님용 칸은 '현판 전체 보기' 뒤로.
export const ACADEMY_SHORTCUTS = ['TIMETABLE', 'SHUTTLE', 'STAFF_INTRO', 'ACADEMY_EVENT', 'CONSULT', 'PHONE', 'MAP', 'OWNER_NOTE'];
// 교회 템플릿 — 10/1 성도 홈 CHURCH_HOME_SKIP 과 같은 칸 + 학원비 결제를 뺀 나머지를 교회가 정한 순서대로.
export const CHURCH_SKIP = ['NOTICE', 'GALLERY', 'ONLINE_MEMORIAL', 'HOURS', 'COMPANY_INTRO', 'SAVE_BIZ', 'GANPANON', 'DAILY_VERSE', 'DOORBELL', 'TUITION_PAY'];

/** 템플릿 바로가기 칸. tiles = GET /api/user/qr/home 의 org.tiles, removed = QR_TILE_REMOVED, flagOff = 스위치 꺼진 칸 판정. */
export const orgShortcuts = (kind, tiles, { removed = [], flagOff = () => false } = {}) => {
  const usable = (tiles || []).filter(t => t && !removed.includes(t.platform) && !flagOff(t));
  if (kind === 'ACADEMY') return ACADEMY_SHORTCUTS.map(p => usable.find(t => t.platform === p)).filter(Boolean);
  if (kind === 'CHURCH') return usable.filter(t => !CHURCH_SKIP.includes(t.platform)).sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  return [];
};
